export default {
  nav: {
    categories: 'Catagóirí',
    topSites: 'Barrshuíomhanna',
    compare: 'Cuir i gcomparáid',
    submitSite: 'Cuir suíomh isteach',
    about: 'Maidir linn',
    logIn: 'Logáil isteach',
  },
  common: {
    back: 'Ar ais',
    search: 'Cuardaigh',
    loading: 'Ag lódáil…',
    viewSimilarSites: 'Féach suíomhanna cosúla',
  },
  hero: {
    badge: 'Inneall fionnachtana suíomhanna',
    titleA: 'Aimsigh suíomhanna atá cosúil le',
    titleB: 'do chuid roghanna.',
    titlePrefix: 'Aimsigh suíomhanna atá cosúil le',
    titleAccent: 'do chuid roghanna.',
    subtitle: 'Faigh iomaitheoirí, roghanna eile agus seoda ceilte ar an ngréasán le scóir chosúlachta chruinne.',
    placeholder: 'Cuir isteach fearann (m.sh. stripe.com)',
    inputPlaceholder: 'Cuir isteach fearann (m.sh. stripe.com)',
    step1Label: 'Cuir isteach fearann',
    step1Desc: 'Clóscríobh URL chun tosú',
    step2Label: 'Faigh torthaí',
    step2Desc: 'Aimsíonn an t-inneall suíomhanna cosúla láithreach',
    step3Label: 'Cuir i gcomparáid & roghnaigh',
    step3Desc: 'Déan anailís agus comparáid ar roghanna eile',
    steps: {
      step1Label: 'Cuir isteach fearann',
      step1Desc: 'Clóscríobh URL chun tosú',
      step2Label: 'Faigh torthaí',
      step2Desc: 'Aimsíonn an t-inneall suíomhanna cosúla láithreach',
      step3Label: 'Cuir i gcomparáid & roghnaigh',
      step3Desc: 'Déan anailís agus comparáid ar roghanna eile',
    },
  },
  footer: {
    newsletterTitle: 'Fan cothrom le dáta',
    newsletterDesc: 'Faigh tuairiscí seachtainiúla ar shuíomhanna treochta agus ar roghanna nua.',
    emailPlaceholder: 'do@email.ie',
    subscribe: 'Liostáil',
    brandDesc: 'Aimsigh na naisc fholaithe ar an ngréasán. Faigh suíomhanna cosúil le do chuid roghanna le scóráil chruinn.',
    explore: 'Fiosraigh',
    popular: 'Coitianta',
    company: 'Cuideachta',
    compareSites: 'Cuir suíomhanna i gcomparáid',
    sitesLike: 'Suíomhanna cosúil le',
    contact: 'Teagmháil',
    faq: 'FAQ',
    removeYourSite: 'Bain do shuíomh',
    privacyPolicy: 'Polasaí Príobháideachais',
    termsOfService: 'Téarmaí Seirbhíse',
    rights: 'Gach ceart ar cosaint.',
  },
  notFound: {
    title: 'Úps! Níor aimsíodh an leathanach',
    returnHome: 'Fill ar an mBaile',
  },
  submitPage: {
    ctaTitle: 'An bhfuil aithne agat ar shuíomh iontach?',
    ctaDesc: 'Cabhraigh lenár mbunachar sonraí a mhéadú trí shuíomhanna is fearr leat a chur isteach. Ní thógfaidh sé ach cúpla soicind.',
    ctaButton: 'Cuir suíomh isteach',
    pageTitle: 'Cuir suíomh isteach',
    pageSubtitle: 'Cabhraigh linn trí shuíomh a chur isteach le go n-innéacsófar é.',
    successTitle: 'Suíomh curtha isteach!',
    successReviewPrefix: 'Déanfaimid athbhreithniú ar',
    successReviewSuffix: 'agus cuirfimid leis an innéacs go luath é.',
    backHome: 'Fill ar an mBaile',
    domainLabel: 'Fearann *',
    domainPlaceholder: 'm.sh. example.com',
    descriptionLabel: 'Cur síos',
    descriptionPlaceholder: 'Cur síos gairid ar an suíomh',
    categoryLabel: 'Catagóir',
    categorySelect: 'Roghnaigh catagóir',
    alternativeTo: 'Malartach do (roghnach)',
    alternativeNone: 'Ceann ar bith — ní malartach é',
    emailLabel: 'Do r-phost',
    emailPlaceholder: 'tu@sampla.ie',
    submitButton: 'Seol suíomh',
    submitFailed: 'Theip ar an seoladh',
    seoTitle: 'Cuir suíomh isteach | CiteMatch',
    seoDesc: 'Cuir suíomh isteach le go n-innéacsófar ar CiteMatch é.',
  },
};

